import { render, staticRenderFns } from "./FileAdapterEdit.vue?vue&type=template&id=08b98609"
import script from "./FileAdapterEdit.vue?vue&type=script&lang=js"
export * from "./FileAdapterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports